import { useEffect } from 'react';
import { Button, TextField, Grid, Fab, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import { LoadingPage , Icons} from 'components';
import createToast from 'components/Toast/Toast';
import { useCopy } from 'hooks';
import OperationDialog from '../../InvoiceDebtor/components/OperationDialog';
import InvoiceServices from '../../InvoiceDetails/services/InvoiceDetailsServices';
import useCustomHook from '../hooks';

export default function SharePaymentLinkDialog({ open, setOpen, invoice }) {
  const { copyItem } = useCopy();
  const { loading, setLoading, link, setLink } = useCustomHook();
  const classes = useStyle();

  const hint = 'لینک پرداخت';
  const getShareLink = async () => {
    setLoading(true);
    try {
      const result = await InvoiceServices.getInvoice(invoice.invoiceId);
      if (result.count > 0) {
        try {
          const res = await InvoiceServices.paymentLink(result.result[0].uniqueNumber);
          setLink(res?.data?.result);
        } catch (error) {
          setOpen(false);
        }
      } else {
        createToast('خطا', 'فاکتور مورد نظر یافت نشد', 'danger');

        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
    } finally {
      setLoading(false);
    }
  };

  const shareLink = (url) => window.open(url, '_blank');
  const telegramShare = () => shareLink(`https://telegram.me/share/url?url=${link}&text=${hint}`);

  const whatsappShare = () => shareLink(`https://wa.me/send?text=${link}`);

  const gmailShare = () =>
    shareLink(
      `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=${hint}&body=${link}&ui=2&tf=1&pli=1`,
    );

  useEffect(() => {
    open && getShareLink();
  }, [invoice, open]);
  return (
    <OperationDialog title="اشتراک گذاری لینک پرداخت" open={open} setOpen={setOpen}>
      {loading ? (
        <LoadingPage width="20%" height="20%" style={{ transform: 'scale(4)' }} />
      ) : (
        <>
          <Grid alignItems="center" container>
            <Grid xs={12} item>
              <TextField
                style={{ direction: 'ltr', textAlign: 'center' }}
                fullWidth
                variant="outlined"
                value={link}
                disabled
              />
            </Grid>
            <Grid xs={12} item>
              <Button variant="contained" color="primary" fullWidth onClick={() => copyItem(link)}>
                کپی کردن لینک
              </Button>
            </Grid>
          </Grid>
          <Grid className={classes.shareLinks}>
            <Tooltip title="اشتراگ گذاری لینک با تلگرام">
              <Fab
                onClick={telegramShare}
                className={clsx(classes.shareLink, classes.telegramIcon)}
              >
                <span className={classes.extendedIcon}>
                  <Icons icon="telegram" color="#676767ff" size="25" />
                </span>
              </Fab>
            </Tooltip>
            <Tooltip title="اشتراگ گذاری لینک با واتس اپ">
              <Fab
                onClick={whatsappShare}
                className={clsx(classes.shareLink, classes.whatsAppIcon)}
              >
                <span className={classes.extendedIcon}>
                  <Icons icon="whatsapp" color="#676767ff" size="25" />
                </span>
              </Fab>
            </Tooltip>
            <Tooltip title="اشتراگ گذاری لینک با جیمیل">
              <Fab onClick={gmailShare} className={clsx(classes.shareLink, classes.emailIcon)}>
                <span className={classes.extendedIcon}>
                  <Icons icon="email" color="#676767ff" size="25" />
                </span>
              </Fab>
            </Tooltip>
          </Grid>
        </>
      )}
    </OperationDialog>
  );
}

const useStyle = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column !important',
  },

  title: { fontSize: '1.5em' },
  textWrapper: {
    marginTop: '1em',
  },
  button: {
    marginTop: '1em',
  },
  shareLinks: {
    marginTop: '1em',
    textAlign: 'center',

  },
  shareLink: {
    marginLeft: '.5em',
    color: 'white',
    width: '40px',
    height: '40px',
    background: '#fff',
    boxShadow: 'none',
    padding: 20,
    border: '2px solid #2b3990',
  },
  extendedIcon: { height: 25 }
}));
